import { FeedbackTag, TagBoxContainer } from 'components';
import { useNavigate } from 'react-router-dom';
import { useAPI, useProduct } from 'stores';

interface FeedbackTagBoxProps {
	title?: string;
}

const FeedbackTagBox = ({ title }: FeedbackTagBoxProps) => {
	const navigate = useNavigate();
	const product = useProduct();
	const { getFeedbackHistory } = useAPI();

	if (!product) return <></>;

	return (
		<>
			<TagBoxContainer
				queryKey={[
					'feedbackHistoryListData',
					product.currentReqUAID,
					title,
				]}
				queryFn={async ({ pageParam = 0 }) => {
					const res = await getFeedbackHistory(
						product.currentReqUAID,
						pageParam + 1,
						title
					);
					if (res?.data?.totalCount === 0 && !title) {
						navigate('/Feedback', {
							replace: true,
							state: { isFirst: true },
						});
					}
					return res;
				}}
				TagComponent={FeedbackTag}
			/>
		</>
	);
};

export default FeedbackTagBox;
